import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../utils/app-context.js";
import StoryPartForm from "../story-part-form.js";
import { Router, useNavigate } from "react-router-dom";
import firebase, { analytics } from "../../utils/firebase.js";
import ConfirmDialog from "./confirm.js"

import { Typography, Box, Tab, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Input, MenuItem, Button, FormControl, Container, Link, Select, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from "@mui/material"
import { Close } from '@mui/icons-material';
import Grid from '@mui/material/Unstable_Grid2'
import theme from '../../styles/theme.js'
import { methods } from "../../constants/index.js";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import hostConfig from "../../utils/config.js";

function ManageModelsDialog(props) {

  const { state, dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const [defaultModels, setDefaultModels] = useState(state.stories.activeStory?.defaultModels || {});
  const [disallowedModels, setDisallowedModels] = useState(state.stories.activeStory?.disallowedModels || []);
  const { open, onClose } = props;
  const story = state.stories.activeStory
  const isOwner = state.app.userIsStoryOwner;
  const [tabValue, setTabValue] = useState('defaults');
  const models = hostConfig.aiModels;

  const handleDisallowChange = (model_key) => {
    let newDisallowed = [...disallowedModels];
    if (newDisallowed.includes(model_key)) {
      newDisallowed = newDisallowed.filter((item) => item !== model_key);
    } else {
      newDisallowed.push(model_key);
    }
    setDisallowedModels(newDisallowed);
    dispatch({ type: "UPDATE_STORY_MODELS", payload: { disallowedModels: newDisallowed } });
  }

  const getModelRefText = (method, model) => {
    const modelData = models.get(model);
    const max = modelData.maxRefs || 0;
    const methodData = methods.get(method);
    const total = max + (methodData.requiresMedia ? 1 : 0);
    return `${total} ref${total != 1 ? 's' : ''}`;
  }

  const updateDefaultModel = (method_key, model_key) => {
    if (isOwner) {
      let newDefaultModels = defaultModels ? defaultModels : {};
      const defaultModel = methods.get(method_key).defaultModel
      if ((model_key == defaultModel) && defaultModels[method_key]) {
        newDefaultModels = { ...defaultModels, [method_key]: null };
      } else {
        newDefaultModels = { ...newDefaultModels, ...{ [method_key]: model_key } };
      }
      setDefaultModels(newDefaultModels)
      dispatch({ type: "UPDATE_STORY_MODELS", payload: { defaultModels: newDefaultModels } });
    }
  }

  const checkDefaults = () => {
    let newDefaults = defaultModels ? defaultModels : {};
    if (newDefaults.length == 0) return;
    for (const [method_key, model_key] of Object.entries(newDefaults)) {
      if (disallowedModels.includes(model_key)) {
        newDefaults = { ...defaultModels, [method_key]: null };
      }
    }
    if (newDefaults !== defaultModels) {
      setDefaultModels(newDefaults);
      dispatch({ type: "UPDATE_STORY_MODELS", payload: { defaultModels: newDefaults } });
    }
  }

  const renderDefaults = () => {
    return (<Box>
      {Array.from(methods).map(([key, value]) => {
        if (key == 'reimagine') return null;
        return (
          <Box
            key={key}
            sx={{
              padding: '10px 0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ marginRight: '20px', width: '150px' }}>
              <Typography variant="body2" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                {value.name}
              </Typography>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Select
                fullWidth
                value={defaultModels[key] || value.defaultModel}
                onChange={(e) => updateDefaultModel(key, e.target.value)}
                sx={{ minWidth: '120px' }}
              >
                {Array.from(models).filter(([modelKey, modelValue]) => modelValue.method === key && !disallowedModels.includes(modelKey)).map(([modelKey, modelValue]) => (
                  <MenuItem key={modelKey} value={modelKey} sx={{ display: 'block', padding: '10px !important' }}>
                    {modelValue.name + " (" + getModelRefText(key, modelKey) + ")"}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>)
      })}
    </Box>)
  }

  const renderDisallowed = () => {

    return (
      <Box>
        {Array.from(methods).map(([key, value]) => {
          if (key == 'reimagine') return null;
          return (
            <Box key={key} sx={{ marginBottom: '30px' }}>
              <Typography variant="h6" sx={{ fontSize: '14px' }}>
                {value.name}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: state.app.isMobileSize ? 'column' : 'row', flexWrap: 'wrap', padding: '10px' }}>
                {Array.from(models).filter(([modelKey, modelValue]) => modelValue.method === key).map(([modelKey, modelValue]) => (
                  <Box key={modelKey} sx={{ width: "calc(50% - 20px)", padding: '10px' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={modelKey}
                          checked={disallowedModels.includes(modelKey)}
                          onChange={() => handleDisallowChange(modelKey)}
                        />
                      }
                      label={modelValue.name}
                      disabled={defaultModels && Object.values(defaultModels).find(model => model == modelKey) ? true : false}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          )
        })}
      </Box>
    )
  }

  const renderSummary = () => {
    let summary = [];
    for (const [key, value] of methods) {
      summary.push(<Box sx={{ display: "flex", marginBottom: "15px" }}>
        <Typography key={key} variant="body2" sx={{ width: "100px" }}>
          {value.name}:
        </Typography>
        <Typography key={key + "-setting"} variant="body2" sx={{ marginBottom: '20px', color: '#555' }}>
          {defaultModels && Array.from(defaultModels).find(([modelKey, modelValue]) => modelValue.method == key) ? hostConfig.aiModels.get(Array.from(defaultModels).find(([modelKey, modelValue]) => modelValue.method == key)[1].model).name : hostConfig.aiModels.get(value.defaultModel).name}
        </Typography>
      </Box>)
    }
    return summary.map((item) => item)
  }

  const renderInfo = () => {
    return (
      <>
        {Array.from(methods).map(([key, value]) => {
          if (key == 'reimagine') return null;
          return (
            <Box key={key} sx={{ marginBottom: '30px' }}>
              <Typography variant="h6" sx={{ fontSize: '14px' }}>
                {value.name}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: state.app.isMobileSize ? 'column' : 'row', flexWrap: 'wrap', padding: '10px' }}>
                <TableContainer component={Paper}>
                  <Table sx={{ width: "100%", }} aria-label="AI Models Configuration">
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Credits</TableCell>
                        <TableCell>Description</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.from(models).filter(([modelKey, modelValue]) => modelValue.method === key).map(([modelKey, modelValue]) => (
                        <TableRow
                          key={modelKey} // Best to use a unique ID like model.id
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {modelValue.name}
                          </TableCell>
                          <TableCell>{modelValue.cost}</TableCell>
                          <TableCell>{modelValue.desc}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          )
        })}
      </>
    );
  }


  const cancelBtn = { click: onClose, type: "tertiary", text: "Cancel" }
  const saveBtn = { click: onClose, type: "primary", text: "Save" }
  const backBtn = { click: onClose, type: "tertiary", text: "Back" }

  const renderModelsSettings = () => {
    if (!story || story.deleted_at) {
      return renderNoStory();
    }
    return isOwner ? renderModels() : renderSummary();
  };

  useEffect(() => {
    if (state.stories.activeStory?.defaultModels) setDefaultModels(state.stories.activeStory.defaultModels)
  }, [state.stories.activeStory?.defaultModels])

  useEffect(() => {
    if (state.stories.activeStory?.disallowedModels) setDisallowedModels(state.stories.activeStory.disallowedModels)
    checkDefaults();
  }, [state.stories.activeStory?.disallowedModels])


  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth="sm"
      sx={{ margin: "0 30px" }}
      id="take-preview-dialog"
    >
      <DialogTitle sx={{ padding: "14px 20px 0", [theme.breakpoints.down("md")]: { padding: "1em 1em 0" } }}>
        Default Model Settings

        <Box onClick={onClose} sx={{ float: "right", "&:hover": { cursor: "pointer" } }}>
          <Close className="icon" />
        </Box>
      </DialogTitle>
      <TabContext value={tabValue} aria-label='basic tabs'>
        <TabList onChange={(event, newValue) => setTabValue(newValue)} sx={{ marginBottom: "15px" }}>
          <Tab
            label='Defaults'
            value='defaults'
            sx={{ fontSize: '10px', padding: "4px 5px", marginLeft: "0 !important" }}
          />
          {isOwner && <Tab
            label='Disallowed'
            value='disallowed'
            sx={{ fontSize: '10px', padding: "4px 5px", marginLeft: "0 !important" }}
          />}
          <Tab label='Info' value='info' sx={{ fontSize: '10px', padding: "4px 5px", marginLeft: "0 !important" }} />
        </TabList>
        <DialogContent sx={{ maxWidth: 900, maxHeight: '80vh', overflowY: 'scroll', [theme.breakpoints.down("md")]: { maxWidth: "100%" } }}>
          <TabPanel value='defaults' sx={{ padding: 0 }}>
            {renderDefaults()}
          </TabPanel>
          {isOwner && <TabPanel value='disallowed' sx={{ padding: 0 }}>
            {renderDisallowed()}
          </TabPanel>}
          <TabPanel value='info' sx={{ padding: 0 }}>
            {renderInfo()}
          </TabPanel>
        </DialogContent>
        <DialogActions sx={{ padding: "1em 1.5em", [theme.breakpoints.down("md")]: { padding: "1em 1em" } }}>
          <Button onClick={onClose} variant="outlined" color="primary">
            Close
          </Button>
        </DialogActions>
      </TabContext>
    </Dialog>
  )
}

export default ManageModelsDialog
